import React, { useState } from 'react'
 
 
import VoucherList from './VoucherList';
import VoucherForm from './VoucherForm';

const Voucher= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <VoucherForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <VoucherList addForm={setFromIsShown} update={setUpData}   sId={setServiceId}/>
        )}  
    </>
  )
}

export default Voucher